<template>
  <div>
    <div class="placeholder" :style="styles">
      <slot>
	<h1 class="is-size-2 is-uppercase" style="color: rgba(0, 0, 0, 0.0875)">{{ label }}</h1>
      </slot>
    </div>
  </div>
</template>

<style>
 .placeholder {
   display: flex;
   justify-content: center;
   align-items: center;
   background-color: rgba(0, 0, 0, 0.075);
 }
</style>

<script>
 export default {
   props: {
     id: Number,
     label: String,
     width: {
       type: Number,
       default: 480
     },
     height: {
       type: Number,
       default: 320
     }
   },
   computed: {
     styles() {
       return {
	 width: `${this.width}px`,
	 height: `${this.height}px`,
       }
     }
   }
  }
</script>
